import React from "react";

export default {
  plate: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="207.082"
      height="146.058"
      viewBox="0 0 207.082 146.058"
    >
      <g transform="translate(-0.001 -53.35)">
        <g transform="translate(0.001 53.35)">
          <path
            d="M133.078,53.35c-41.18,0-74.555,32.7-74.555,73.029s33.375,73.029,74.555,73.029,74.555-32.692,74.555-73.029S174.245,53.35,133.078,53.35Zm-.822,119.818c-25.852,0-46.8-20.517-46.8-45.839s20.948-45.842,46.8-45.842,46.8,20.52,46.8,45.842S158.1,173.168,132.256,173.168Z"
            transform="translate(-27.453 -53.35)"
            fill="#fff"
          />
          <path
            d="M24.523,77.69H21.315l.957,31.757H18.418V77.69H15.6v31.954H12.407V77.69L9.289,77.7V109.65H5.5L6.586,77.69H3.647L.095,104.722S0,105.74,0,106.129A12.946,12.946,0,0,0,5.25,116.438C15.787,127.679,8.591,139.152,8.6,141.88c.006,3.01.006,49.437.006,49.437.007.036-.013.061-.006.1a5.3,5.3,0,0,0,5.447,5.142,5.314,5.314,0,0,0,5.456-5.142c-.007-.043-.013-.067-.02-.1h.013s0-45.845.007-49.333c0-3.175-6.08-16.355,4.078-26.165a.243.243,0,0,1,.049-.058,12.92,12.92,0,0,0,4.357-8.721c.02-.239.013-.855.013-.855Z"
            transform="translate(-0.001 -64.098)"
            fill="#fff"
          />
          <path
            d="M367.765,154.346c.006-3.065-.1-76.649-.1-76.649l-1.778-.006s-14.495,7.726-14.495,65.06c11.134,2.887,6.449,14.385,5.606,15.849,0,2.918.24,32.9.24,32.9l.039-.018a.357.357,0,0,0-.026.1,5.264,5.264,0,0,0,10.511,0,.1.1,0,0,0,0-.086l.006-.025S367.771,157.711,367.765,154.346Z"
            transform="translate(-160.691 -64.098)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  ),
  vegetarian: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      id="Layer_1"
      x="0px"
      className="course__vegetarian"
      y="0px"
      viewBox="0 0 469.343 469.343"
    >
      <g>
        <g>
          <path d="M468.523,6.597c-1.643-3.989-5.547-6.592-9.856-6.592C44.693,0.005,0,171.567,0,245.338c0,95.701,72.875,160,181.333,160    c136.981,0,165.675-130.347,181.099-200.363C383.168,110.703,428.8,55.663,466.219,18.223    C469.269,15.173,470.187,10.586,468.523,6.597z M341.589,200.389c-19.563,88.832-49.664,183.616-160.256,183.616    c-95.701,0-160-55.723-160-138.667c0-65.899,40.789-217.259,412.16-223.787C398.229,60.357,360.32,115.162,341.589,200.389z" />
        </g>
      </g>
      <g>
        <g>
          <path d="M297.6,112.687c-2.581-5.291-8.96-7.488-14.251-4.949C109.973,191.749,0,395.247,0,458.671    c0,5.888,4.779,10.667,10.667,10.667s10.667-4.779,10.667-10.667c0-49.856,96.235-246.891,271.317-331.733    C297.941,124.357,300.16,117.978,297.6,112.687z" />
        </g>
      </g>
    </svg>
  ),
  vegetarianSmall: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.086"
      height="23.066"
      viewBox="0 0 23.086 23.066"
    >
      <g transform="translate(1 0.995)">
        <g transform="translate(0 0.005)">
          <g transform="translate(0 0)">
            <path
              d="M21.029.3a.479.479,0,0,0-.442-.3C2.006.005,0,7.705,0,11.017c0,4.3,3.271,7.181,8.139,7.181,6.148,0,7.436-5.85,8.128-8.993A16.213,16.213,0,0,1,20.926.823.478.478,0,0,0,21.029.3ZM15.332,9c-.878,3.987-2.229,8.241-7.193,8.241-4.3,0-7.181-2.5-7.181-6.224,0-2.958,1.831-9.751,18.5-10.044A16.884,16.884,0,0,0,15.332,9Z"
              transform="translate(0 -0.005)"
              fill="#4ba085"
              stroke="#4ba085"
              strokeWidth="2"
            />
          </g>
        </g>
        <g transform="translate(0 4.793)">
          <g transform="translate(0)">
            <path
              d="M13.357,106.953a.481.481,0,0,0-.64-.222C4.936,110.5,0,119.635,0,122.482a.479.479,0,0,0,.958,0c0-2.238,4.319-11.081,12.178-14.889A.48.48,0,0,0,13.357,106.953Z"
              transform="translate(0 -106.683)"
              fill="#4ba085"
              stroke="#4ba085"
              strokeWidth="2"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  table: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="247.628"
      className="course__table"
      viewBox="0 0 247.628 289.954"
    >
      <g transform="translate(-246.553 -209)">
        <rect
          width="247"
          height="238"
          transform="translate(247 209)"
          fill="#c20404"
        />
        <path
          d="M910.446,452.014s4.421,35.259-8.423,42.591-32.555,18.312-65.1,20.171-50.256-11.417-77.762-14.168S701.4,513.444,679.4,509.777s-14.67-57.762-14.67-57.762Z"
          transform="translate(-417 -16)"
          fill="#c20404"
        />
      </g>
    </svg>
  ),
  place: (
    <svg
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 513.597 513.597"
    >
      <g>
        <path
          d="M263.278,0.107C158.977-3.408,73.323,80.095,73.323,183.602c0,117.469,112.73,202.72,175.915,325.322
		c3.208,6.225,12.169,6.233,15.388,0.009c57.16-110.317,154.854-184.291,172.959-290.569
		C456.331,108.387,374.776,3.866,263.278,0.107z M256.923,279.773c-53.113,0-96.171-43.059-96.171-96.171
		s43.059-96.171,96.171-96.171c53.113,0,96.172,43.059,96.172,96.171S310.036,279.773,256.923,279.773z"
        />
      </g>
    </svg>
  ),
};
